import { IFieldData } from "./FieldListener";

export function extractNDC(substr: string): IFieldData | undefined {
  if (substr.length !== 14) return;
  const data = substr.substring(3, 13);
  return { fieldAI: "", fieldName: "ndc", data };
}
